import { formatCurrency, formatNumber } from '../utils/format';
import './RefLinks.css';

interface RefLinkInfo {
  ref_id: string;
  ref_name: string;
  ref_code: string;
  commission_rate: number;
  total_deposits: number;
  balance: number;
  players_count: number;
}

interface RefLinksProps {
  refLinks: RefLinkInfo[];
}

export function RefLinks({ refLinks }: RefLinksProps) {
  if (!refLinks || refLinks.length === 0) {
    return (
      <div className="reflinks-container">
        <h2 className="reflinks-title">📊 Реферальные ссылки</h2>
        <div className="reflinks-empty">
          <p>Нет активных реферальных ссылок</p>
        </div>
      </div>
    );
  }

  return (
    <div className="reflinks-container">
      <h2 className="reflinks-title">📊 Реферальные ссылки</h2>
      
      <div className="reflinks-list">
        {refLinks.map((link) => (
          <div key={link.ref_id} className="reflink-card">
            <div className="reflink-header">
              <h3 className="reflink-name">{link.ref_name}</h3>
              <span className="reflink-code">#{link.ref_code}</span>
            </div>
            
            <div className="reflink-stats">
              <div className="reflink-stat">
                <div className="reflink-stat-icon">👥</div>
                <div className="reflink-stat-content">
                  <p className="reflink-stat-label">Игроков</p>
                  <p className="reflink-stat-value">{formatNumber(link.players_count)}</p>
                </div>
              </div>
              
              <div className="reflink-stat">
                <div className="reflink-stat-icon">💰</div>
                <div className="reflink-stat-content">
                  <p className="reflink-stat-label">Баланс</p>
                  <p className="reflink-stat-value">{formatCurrency(link.balance)}</p>
                </div>
              </div>
              
              <div className="reflink-stat">
                <div className="reflink-stat-icon">📈</div>
                <div className="reflink-stat-content">
                  <p className="reflink-stat-label">Депозитов</p>
                  <p className="reflink-stat-value">{formatCurrency(link.total_deposits)}</p>
                </div>
              </div>
              
              <div className="reflink-stat">
                <div className="reflink-stat-icon">%</div>
                <div className="reflink-stat-content">
                  <p className="reflink-stat-label">Комиссия</p>
                  <p className="reflink-stat-value">{(link.commission_rate * 100).toFixed(0)}%</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
